export default __webpack_public_path__ + "static/media/logo_autopass.98103557.svg";